const customerHistoryLabels: Record<string, string> = {
  AI_USE_CREATED: 'AI use created',
  AI_USE_EDIT_STARTED: 'Private edit draft opened',
  AI_USE_UPDATED: 'AI use updated',
  AI_USE_SCREENING_COMPLETED: 'Initial governance check completed',
  AI_USE_BUSINESS_OWNER_ASSIGNED: 'Business owner assigned',
  AI_USE_TECHNICAL_OWNER_CONFIRMED: 'Technical owner confirmed',
  AI_USE_TECHNICAL_CLASSIFICATION_CONFIRMED: 'Technical classification confirmed',
  MATERIAL_CHANGE_REPORTED: 'Material change recorded',
  MATERIAL_CHANGE_TRIAGED: 'Material change reviewed',
  ASSESSMENT_STARTED: 'Formal Assessment started',
  ASSESSMENT_FINALISED: 'Formal Assessment completed',
  APPROVAL_REQUEST_CREATED: 'Approval requested',
  APPROVAL_DECIDED: 'Approval decision recorded',
  P4_USE_CASE_CREATED: 'AI use created',
  P4_USE_CASE_UPDATED: 'AI use updated',
  P4_USE_CASE_OPERATIONAL_STATE_CHANGED: 'Operational state changed',
  R1_CONFIRMATION_ASSIGNED: 'Specialist confirmation assigned',
  R1_CONFIRMATION_ASSIGNEE_INVITED: 'Specialist confirmation invitation created',
  R1_CONFIRMATION_INVITATION_ACTIVATED: 'Specialist confirmation invitation activated',
  R1_CONFIRMATION_INVITATION_UNAVAILABLE: 'Specialist confirmation invitation unavailable',
  R1_CONFIRMATION_REASSIGNED: 'Specialist confirmation reassigned',
  R1_CONFIRMATION_CANCELLED: 'Specialist confirmation cancelled',
  R1_CONFIRMATION_COMPLETED: 'Specialist confirmation completed',
  R1_CONFIRMATION_REASSESSMENT_STARTED: 'Reassessment started',
  R1_CONFIRMATION_INFORMATION_REQUESTED: 'Information requested',
  R1_CONFIRMATION_INFORMATION_RECIPIENT_INVITED: 'Information recipient invited',
  R1_INFORMATION_REQUEST_INVITATION_ACTIVATED: 'Information request invitation activated',
  R1_CONFIRMATION_INFORMATION_ANSWERED: 'Information request answered',
  R1_INFORMATION_REQUEST_REASSIGNED: 'Information request reassigned',
  R1_INFORMATION_REQUEST_CANCELLED: 'Information request cancelled',
  R1_INFORMATION_REQUEST_INVITATION_UNAVAILABLE: 'Information recipient invitation unavailable',
  R1_CONTEXTUAL_INVITATION_DELIVERY_ATTEMPT_RECORDED: 'Invitation delivery attempt recorded',
  R1_CONTEXTUAL_INVITATION_RESEND_REQUESTED: 'Invitation resend requested',
  R1_CONTEXTUAL_INVITATION_CANCELLED: 'Invitation cancelled',
}

/**
 * Maps immutable audit event codes to customer-facing history copy.
 *
 * Audit event_type values remain unchanged in the database and API. Unknown
 * future codes deliberately use neutral copy rather than leaking an internal
 * identifier into a customer history view.
 */
export function customerHistoryLabel(eventType: unknown): string {
  if (typeof eventType !== 'string' || !eventType) return 'Governance record updated'
  return customerHistoryLabels[eventType] ?? 'Governance record updated'
}
